import React from "react"
import { formatEnrolledTotal } from "../helper"
import { formatMoney } from "../../../../utils/amount"
import { describeDebtOwner } from "../../../../components/CreditReports/debtOwner"

export const EnrolledDebtsCard = ({ selectedCreditLines, isSignedMainDoc, coApplicantId }) => {
  const lines = Array.isArray(selectedCreditLines) ? selectedCreditLines : []
  const status = isSignedMainDoc ? "Enrolled" : "Selected"
  const showOwner = Boolean(coApplicantId)

  return (
    <div className="bg-surface border border-divider shadow-lg rounded-2xl w-full max-w-[798px] mt-6">
      <div className="font-bold text-xl-20 pt-[24px] pl-[48px] pb-[16px]">
        Enrolled Debts
      </div>
      <div className="border-b border-divider mx-6" />
      {lines.length > 0 ? (
        <div className="px-12 my-6">
          <table className="w-full">
            <thead>
              <tr className="border-b border-divider">
                <th className="py-2 pr-4 text-left text-[13px] font-semibold text-text-secondary">Creditor</th>
                <th className="py-2 pr-4 text-left text-[13px] font-semibold text-text-secondary">Balance</th>
                <th className="py-2 pr-4 text-left text-[13px] font-semibold text-text-secondary">Status</th>
                {showOwner && (
                  <th className="py-2 text-left text-[13px] font-semibold text-text-secondary">Owner</th>
                )}
              </tr>
            </thead>
            <tbody>
              {lines.map((line, index) => (
                <tr key={`${line?._id ?? "line"}-${index}`} className="border-b border-divider last:border-0">
                  <td className="py-3 pr-4 text-sm text-text-primary">
                    {line?.creditorName || line?.bankAccount || "—"}
                  </td>
                  <td className="py-3 pr-4 text-sm text-text-primary font-medium">
                    {formatMoney(line?.balanceAmount || 0)}
                  </td>
                  <td className="py-3 pr-4 text-sm text-text-primary">{status}</td>
                  {showOwner && (
                    <td className="py-3 text-sm text-text-primary">
                      {describeDebtOwner(line?.user === coApplicantId ? "co-applicant" : "applicant")}
                    </td>
                  )}
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      ) : (
        <div className="px-12 my-6 font-normal text-md text-text-secondary">
          No debts selected
        </div>
      )}
      <div className="border-b border-divider mx-6" />
      <div className="flex justify-between px-12 my-6">
        <div className="font-normal text-md text-text-secondary">
          Total Enrolled Debt
        </div>
        <div className="font-bold text-[12px] text-text-primary">
          {formatEnrolledTotal(lines)}
        </div>
      </div>
    </div>
  )
}
